import Layout from "../components/Layout";
import "../styles/contact.css";

const Contact = () => (
  <Layout>
    <section className="contact-page" aria-labelledby="contact-heading">
      <div className="contact-copy">
        <h1 id="contact-heading">Контакты</h1>
        <p>Дарья Немкович<br />Портретный фотограф<br />Варшава, Польша</p>
        <div className="contact-links"><a href="https://www.instagram.com/darianemkovich/" target="_blank" rel="noopener noreferrer">Инстаграм ↗</a></div>
        <a href="https://ig.me/m/darianemkovich" target="_blank" rel="noopener noreferrer" className="outline-button">Написать в Инстаграм</a>
      </div>
      <img className="contact-portrait" src="/static/img/contact-portrait-72cce580c2be.jpg" alt="Чёрно-белый портрет с полевыми цветами" width="3995" height="2996" />
    </section>
  </Layout>
);

export default Contact;
